module.exports = __webpack_public_path__ + "static/media/m25b_thumb_even.572bb5f1.webp";